import { API_Orders_VismaSearch } from "../Shared/Urls.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { obj_type, unit_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { fromString as fromString_1, Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Order_$reflection, GenericResponse_$reflection } from "../Shared/ApiDataTypes.js";
import { unwrap, map, defaultArg, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "../Promises.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { condDisabledTooltip, SnackAlert, SnackAlertLevel } from "../ViewHelpers.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TextField, CircularProgress, Button } from "@mui/material";
import { empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import Search from "@mui/icons-material/Search";
import { fromSeconds } from "../fable_modules/fable-library-js.4.24.0/TimeSpan.js";

function Orders_searchVismaOrder(companyId, customerId, vismaNumberStr, callback) {
    let properties_2;
    const url = API_Orders_VismaSearch(companyId, customerId, vismaNumberStr);
    let pr_1;
    const body = void Auto_generateBoxedEncoder_437914C6(unit_type, undefined, undefined, undefined)();
    const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
    const data_1 = some(body);
    const caseStrategy_3 = undefined;
    const extra_3 = undefined;
    try {
        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    pr_1.then((res) => {
        callback(res);
    });
}

export function Orders_VismaSearchButton(orders_VismaSearchButtonInputProps) {
    let elems_3, elems_2;
    const callback = orders_VismaSearchButtonInputProps.callback;
    const customerId = orders_VismaSearchButtonInputProps.customerId;
    const companyId = orders_VismaSearchButtonInputProps.companyId;
    const white = orders_VismaSearchButtonInputProps.white;
    const disabled = orders_VismaSearchButtonInputProps.disabled;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setSearching = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const showSearchBar = patternInput_1[0];
    let patternInput_2;
    const initial_2 = {
        level: new SnackAlertLevel(1, []),
    };
    patternInput_2 = reactApi.useState(initial_2);
    const setError = patternInput_2[1];
    const error = patternInput_2[0];
    const xs_4 = [createElement(SnackAlert, {
        key: "visma-order-search",
        $key: "visma-order-search",
        level: error.level,
        msg: unwrap(error.message),
        dismiss: () => {
            setError({
                level: error.level,
            });
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        columnGap: 10 + "px",
    }], (elems_3 = [condDisabledTooltip(ctx.Locale.t("Orders.ChooseCompany"), disabled, MuiHelpers_createElement(Button, toList(delay(() => append(singleton(["style", createObj(toList(delay(() => (white ? singleton(["backgroundColor", "white"]) : empty_1()))))]), delay(() => append(singleton(["onClick", (_arg) => {
        patternInput_1[1](!showSearchBar);
    }]), delay(() => append(!white ? singleton(["variant", "contained"]) : singleton(["variant", "outlined"]), delay(() => append(singleton(["color", "primary"]), delay(() => {
        let props_2;
        return append(singleton(["startIcon", patternInput[0] ? MuiHelpers_createElement(CircularProgress, [["style", createObj(toList(delay(() => (!white ? singleton(["color", "#FFFFFF"]) : empty_1()))))], ["size", 25]]) : ((props_2 = {
            style: createObj(toList(delay(() => (!white ? singleton(["color", "white"]) : empty_1())))),
        }, react.createElement(Search, props_2)))]), delay(() => append(singleton(["disabled", disabled]), delay(() => {
            let elements, elems;
            return singleton((elements = [createElement("div", createObj(ofArray([["style", {
                transitionProperty: "width",
                transitionDuration: fromSeconds(0.5) + "ms",
                width: !showSearchBar ? (12 + "ch") : (0 + "ch"),
                overflow: "hidden",
            }], (elems = [createElement("div", {
                style: {
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                },
                children: ctx.Locale.t("Orders.SearchInVisma"),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elements))]));
        }))));
    })))))))))))), createElement("div", createObj(ofArray([["style", {
        overflow: "hidden",
        width: showSearchBar ? (20 + "ch") : (0 + "ch"),
        transitionProperty: "width",
        transitionDuration: fromSeconds(0.5) + "ms",
    }], (elems_2 = [MuiHelpers_createElement(TextField, [["variant", "outlined"], ["size", "small"], ["color", "primary"], ["classes.root", "white-background-parent"], ["placeholder", ctx.Locale.t("Orders.Number")], ["onClick", (ev) => {
        ev.stopPropagation();
    }], ["onBlur", (ev_1) => {
        const target = ev_1.target;
        target.value = "";
    }], ["onKeyUp", (keyEvent) => {
        if (keyEvent.code === "Enter") {
            const vismaNum = keyEvent.target.value;
            setSearching(true);
            Orders_searchVismaOrder(companyId, customerId, vismaNum, (res) => {
                setSearching(false);
                if (res.tag === 0) {
                    const resp = res.fields[0];
                    switch (resp.Result) {
                        case "exists": {
                            console.error(some(resp.Message));
                            setError({
                                level: new SnackAlertLevel(1, []),
                                message: resp.Message,
                            });
                            callback(undefined);
                            break;
                        }
                        case "closed": {
                            console.error(some(resp.Message));
                            setError({
                                level: new SnackAlertLevel(1, []),
                                message: resp.Message,
                            });
                            callback(undefined);
                            break;
                        }
                        case "created": {
                            const orderRes = fromString_1(uncurry2(Auto_generateBoxedDecoder_Z6670B51(Order_$reflection(), undefined, undefined)), resp.Message);
                            if (orderRes.tag === 0) {
                                callback(orderRes.fields[0]);
                            }
                            else {
                                console.error(some("Could not decode order response"), orderRes.fields[0]);
                                callback(undefined);
                            }
                            break;
                        }
                        default: {
                            console.error(some("Unknown response from server when searching from visma order:"), res);
                            setError({
                                level: new SnackAlertLevel(0, []),
                                message: ctx.Locale.t("Orders.UnknownSearchError"),
                            });
                            callback(undefined);
                        }
                    }
                }
                else {
                    console.error(some("Error searching visma for order:"), res.fields[0]);
                    setError({
                        level: new SnackAlertLevel(0, []),
                        message: ctx.Locale.t("Orders.UnknownSearchError"),
                    });
                    callback(undefined);
                }
            });
        }
    }]])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))];
    return react.createElement(react.Fragment, {}, ...xs_4);
}

